import _ from 'underscore';
import classnames from 'classnames';
import React, { useMemo } from 'react';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
// import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getImgExtBingDesktopMultiImage133x100Styles } from '../../styles';
import {
  MMAPlacementCard,
  PlacementHeadline,
  PlacementFinalUrl,
  PlacementDescription,
} from '../../shared-components';

// multi-image placement
const ImgExtBingDesktopMultiImage133x100 = ({
  placementData, // UAPVMPlacement
  isEnabled,
  longHeadline,
  finalUrl,
  description,
  classes,
}) => {
  //
  const { placementMeta, images = [] } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};

  // there are 4 images in the placement, the last 3 are placeholder images
  const imagesWithPadding = useMemo(
    () => [0, 1, 2, 3].map(index => (images && images[index]) || _.last(images)),
    [images]
  );

  if (!placementData || !placementMeta || _.isEmpty(images)) {
    return null;
  }

  const imagePreviewWidth = previewHeight * aspectRatio;

  return (
    <MMAPlacementCard width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard}>
      <div className={classnames(classes.placementTextContainer)}>
        <PlacementHeadline
          headlineText={longHeadline}
          isMultiLine
          placementHeadlineClassName={classnames(classes.placementLongHeadline, 'long-headline')}
        />
        <PlacementFinalUrl
          finalUrl={finalUrl}
          isMultiLine
          placementFinalUrlClassName={classnames(classes.placementFinalUrl, 'final-url')}
        />
        <PlacementDescription
          description={description}
          isMultiLine
          placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
        />
      </div>
      <div className={classnames(classes.placementImageContainer)}>
        {
          imagesWithPadding.map(({
            imageMeta, placementCropping, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
          }, idx) => {
            const cropping = expandedPlacementCropping || placementCropping;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div className="bing-desktop-multi-image-item" key={idx}>
                <CroppedImageView
                  resizeImageHeight={previewHeight}
                  aspectRatio={aspectRatio}
                  src={effectiveImageUrl || imageMeta.url}
                  originalWidth={effectiveImageWidth || imageMeta.originalWidth}
                  originalHeight={effectiveImageHeight || imageMeta.originalHeight}
                  SourceX={cropping && cropping.SourceX}
                  SourceY={cropping && cropping.SourceY}
                  SourceWidth={cropping && cropping.SourceWidth}
                  SourceHeight={cropping && cropping.SourceHeight}
                />
              </div>);
          })
        }
      </div>
    </MMAPlacementCard>
  );
};

export const AdPlacementImgExtBingDesktopMultiImage133x100 = withUAPLThemedStyles(
  ImgExtBingDesktopMultiImage133x100,
  getImgExtBingDesktopMultiImage133x100Styles,
  { componentName: 'AdPlacementImgExtBingDesktopMultiImage133x100' }
);
